import { TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { mergeDeep } from "@shared/utils/data.utils";
import { forkJoin, Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

export class MergedHttpLoader extends TranslateLoader {
    constructor(
        protected commonLoader: TranslateHttpLoader,
        protected appLoader?: TranslateHttpLoader,
    ) {
        super();
    }

    getTranslation(lang: string): Observable<any> {
        if (!this.appLoader) return this.commonLoader.getTranslation(lang);
        return forkJoin([
            this.commonLoader.getTranslation(lang),
            this.appLoader.getTranslation(lang).pipe(catchError(() => of({})))
        ]).pipe(map(([common, app]) => mergeDeep(common, app)));
    }

}